// extracted by mini-css-extract-plugin
export default {"skillsets":"Skills_skillsets__35XmH","skillContent":"Skills_skillContent__vzR7V"};